import React from "react";
import { createRoot } from "react-dom/client";
import "react-datepicker/dist/react-datepicker.css";
import { BrowserRouter as Router } from "react-router-dom";
import "@blueprintjs/core/lib/css/blueprint.css";
import "react-tooltip/dist/react-tooltip.css";
import "./index.css";
import App from "./App.jsx";
import * as Sentry from "@sentry/react";

// Microsoft Clarity tracking - only load on postpaddy.com
if (window.location.hostname === "postpaddy.com") {
  (function (c, l, a, r, i, t, y) {
    c[a] =
      c[a] ||
      function () {
        (c[a].q = c[a].q || []).push(arguments);
      };
    t = l.createElement(r);
    t.async = 1;
    t.src = "https://www.clarity.ms/tag/" + i;
    y = l.getElementsByTagName(r)[0];
    y.parentNode.insertBefore(t, y);
  })(window, document, "clarity", "script", "j9fbywnk8i");
}

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  enabled:  process.env.NODE_ENV === 'production',
  integrations: [
    new Sentry.BrowserTracing({
      // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
      tracePropagationTargets: [], //i've set this tp an empty array to disable sending baggage header
    }),
    new Sentry.Replay(),
    new Sentry.Integrations.Breadcrumbs({ console: false }),
  ],
  // Performance Monitoring
  tracesSampleRate: 0.5, // Capture 50% of the transactions
  // Session Replay
  replaysSessionSampleRate: 1.0, // This sets the sample rate at 100%..
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

const container = document.getElementById("root");
try {
  if (!container) {
    throw new Error("Failed to find root element");
  }
  const root = createRoot(container);

  root.render(
    <Router>
      <App />
    </Router>
  );
} catch (error) {
  console.error(error.message);
}
